<template>
  <div class="data-list">
    <div class="head-box">
      <search-box class="search-box">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="80px" size="mini">
          <el-form-item label="核对结果" prop="verifyRes">
            <el-select v-model="searchForm.verifyRes" placeholder="请选择" @change="onSearch">
              <el-option label="全部" value=""> </el-option>
              <el-option label="正常" value="正常"> </el-option>
              <el-option label="异常" value="异常"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="核对时间" prop="updatedTime">
            <q-date-picker 
              v-model="searchForm" 
              startFiled="startDate" 
              endFiled="endDate"
              :isDefault="false"
              ref="dateRef"
            />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </div>
    <content-panel>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="anewCheck">重新核对</el-button>
          <el-button type="primary" size="small" @click="exportFile">导出</el-button>
        </template>
        <el-table stripe v-loading="loading" ref="tableRef" border highlight-current-row :data="tableData" :height="maxTableHeight">
          <el-table-column prop="seqId" label="序号" align="center" width="80"></el-table-column>
          <el-table-column prop="dateTime" label="核对时间" show-overflow-tooltip width="160"></el-table-column>
          <el-table-column prop="dateScope" label="核对周期" align="center" show-overflow-tooltip width="300"></el-table-column>
          <el-table-column prop="orderCount" label="核对订单数" align="center"></el-table-column>
          <el-table-column prop="failOrderCount" label="核对异常订单数" align="center"></el-table-column>
          <el-table-column prop="verifyRes" label="核对结果" align="center">
            <template slot-scope="{ row }">
              <span :style="`${row.verifyRes == '异常' ? 'color: red' : ''}`">{{ row.verifyRes }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="joinNum" label="操作" align="center" width="140">
            <template slot-scope="{ row }">
              <el-button type="text" @click="lookErrResult(row)" v-if="row.verifyRes == '异常'">查看异常结果</el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
      <anew-check-dialog  
        :isShowAnewCheckDialog.sync="isShowAnewCheckDialog"
        @verifySuccess="onSearch"
      />
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import anewCheckDialog from "./anew-check-dialog";
import moment from 'moment';
export default {
  mixins: [tableMixin,pagePathMixin],
  components: {
    anewCheckDialog
  },
  data() {
    return {
      searchForm: {
        verifyRes: "",
        startDate: "",
        endDate: "",
      },

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      isShowAnewCheckDialog: false
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport
        .queryUnionOrderVerifySummary(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (key == 'startDate' && val) {
          this.filterParam[key] = moment(val).format("YYYYMMDD")
        } else if (key == 'endDate' && val) {
          this.filterParam[key] = moment(val).format("YYYYMMDD")
        } else if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.startDate = ''
      this.searchForm.endDate = ''
      this.$refs.dateRef.reset()
    },
    anewCheck() {
      this.isShowAnewCheckDialog = true
    },
    lookErrResult(row) {
      let dateScope = row.dateScope.slice(0, 10)
      this.openSubPage({ path: "/dataReport/errResult", query: {dateScope} });
    },
    exportFile() {
      const params = {
        ...this.filterParam,
      };
      this.$api.common.doExport("queryUnionOrderVerifySummary", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
  },
  filters: {},
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.data-list {
  .head-box {
    margin: 0 15px;
    padding: 10px;
    padding-top: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background: #fff;
  }
  .date-input  {
    width 220px !important
  }
}
</style>
